import { Paragraph } from '@vimeo/iris/typography';

export default function WatchLaterQueue() {
  return (
    <div>
      <Paragraph size="2">
        The <em>Watch Later queue</em> contains all the videos that a Vimeo member has flagged to
        watch later.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
